import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformAuthenticationFormTipCars} from './components/PlatformAuthenticationFormTipCars';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';
import {PlatformTipCarsInfo} from './components/PlatformTipCarsInfo';
import {PlatformTipCarsVin} from './components/PlatformTipCarsVin';

export function PlatformSettingsTipCars() {
  return (
    <>
      <PlatformAuthenticationFormTipCars />
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.TIPCARS} />
      <PlatformTipCarsVin />
      <PlatformTipCarsInfo />
    </>
  );
}
